export { apiRoutesParent, apiRoutesStudent } from "./api-routes.constants";
export { appConfig } from "./config.constants";
export { notificationTypes } from "./notification.constants";
export { statesElement } from "./states.constants";
export { statusCodes } from "./status-codes.constants";
export { pagination } from "./pagination.constants";
export { typeDocuments } from "./type-document.constants";
export { configEditor } from "./editor.constants";
export { cEstadoVenta } from "./estado-venta.constants";
export { cTipoVenta } from "./tipo-venta.constants";
export { statesGenero} from "./genero.constants";
export { cTipoInscripcion} from "./tipo-inscripcion.constants";
export { cEstadoNota} from "./estado-nota.constants";
export { tipoCertificado} from "./tipo-certificado-notas.constants"